import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "../../assets/css/Sign.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    clientLogo1,
    clientLogo2,
    clientLogo3,
    clientLogo4,
    clientLogo5,
    clientLogo6,
} from "../../Constant";
import { LoginAction, SocialLoginAction } from "../../redux/actions/auth";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login";
import AppleSignin from "react-apple-signin-auth";
import config from "../../config";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";

const Signin = ({ auth, loginAction, socialLoginAction }) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        if (auth.loggedIn == false && auth.user && auth.token) {
            if (auth.user.bio == null) {
                navigate("/introduce");
            }
        }
    }, []);

    const login = () => {
        if (!email || !password) {
            return Swal.fire({
                icon: "error",
                title: "Validation ",
                text: "Email and Password is required!",
            });
        }
        loginAction(email, password).then(() => {
            if (auth.loggedIn) {
                navigate("/");
            }
        });
    };

    const socialLogin = async (
        first_name = null,
        last_name = null,
        social_email,
        social_id,
        profile_picture = null
    ) => {
        socialLoginAction(
            first_name,
            last_name,
            social_email,
            social_id,
            profile_picture
        ).then(() => {
            if (auth.loggedIn) {
                navigate("/");
            } else {
                navigate("/introduce");
            }
        });
    };

    const appleLogin = async (token, firstName = null, lastName = null) => {
        const response = jwt_decode(token);
        socialLogin(firstName, lastName, response.email, response.sub);
        // console.log(response);
        // const jwtClaims = await verifyAppleToken(token);
        // console.log(jwtClaims);
    };

    return (
        <>
            <Header />
            <section className="signin_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="signin_box">
                                <div className="heading">
                                    <h5>
                                        <span className="light">Signin to</span>{" "}
                                        My Home Helper
                                    </h5>
                                </div>
                                <div className="signin_by">
                                    <FacebookLogin
                                        appId={
                                            config.socialSignins.facebook
                                                .clientId
                                        }
                                        fields="name,email,picture"
                                        callback={(userinfo) => {
                                            socialLogin(
                                                userinfo.name.split(" ")[0],
                                                userinfo.name.split(" ")[1],
                                                userinfo.email,
                                                userinfo.userID,
                                                userinfo.picture.data.url
                                            );
                                        }}
                                    />
                                    {/* <a
                                        href="#"
                                        className="logins_btn facebook-btn"
                                    >
                                        Continue with Facebook
                                    </a> */}
                                    <br />
                                    <GoogleLogin
                                        isSignedIn={false}
                                        fetchBasicProfile={true}
                                        accessType="offline"
                                        clientId={
                                            config.socialSignins.google.clientId
                                        }
                                        onSuccess={(response) => {
                                            socialLogin(
                                                response.profileObj.givenName,
                                                response.profileObj.familyName,
                                                response.profileObj.email,
                                                response.profileObj.googleId,
                                                response.profileObj.imageUrl
                                            );
                                            // console.log(response);
                                        }}
                                        onFailure={(error) => {
                                            console.log(error);
                                        }}
                                        render={(renderProps) => (
                                            <a
                                                href="#"
                                                className="logins_btn google-btn"
                                                {...renderProps}
                                            >
                                                Continue with Google
                                            </a>
                                        )}
                                    />

                                    <br />
                                    <AppleSignin
                                        authOptions={{
                                            clientId:
                                                config.socialSignins.apple
                                                    .clientId,
                                            scope: "email name",
                                            redirectURI:
                                                config.myUrl +
                                                "/apple-redirect",
                                            usePopup: true,
                                        }}
                                        render={(props) => (
                                            <a
                                                {...props}
                                                href="#"
                                                className="logins_btn apple-btn"
                                            >
                                                Continue with Apple
                                            </a>
                                        )}
                                        onSuccess={(response) => {
                                            appleLogin(
                                                response.authorization.id_token,
                                                response.user?.name?.firstName,
                                                response.user?.name?.lastName
                                            );
                                        }}
                                    />
                                </div>
                                <div className="seprator">
                                    <span>OR</span>
                                </div>
                                <form
                                    onSubmit={(e) => {
                                        console.log("submit");
                                        e.preventDefault();
                                        login();
                                    }}
                                    id="loginForm"
                                    className="form"
                                    action=""
                                    method="post"
                                >
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="Enter your email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pass">Password</label>
                                        <input
                                            type="password"
                                            id="password"
                                            placeholder="Password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) =>
                                                setPassword(e.target.value)
                                            }
                                        />
                                    </div>
                                    <Link
                                        to="/forgot-password"
                                        className="forget_btn"
                                    >
                                        Forgot Password ?
                                    </Link>
                                    <br />
                                    <input
                                        // onClick={login}
                                        id="login-button"
                                        type="submit"
                                        name="submit"
                                        className="logins_btn submit_btn"
                                        value="Sign-In"
                                    />
                                </form>
                                <div className="policyDv">
                                    <p>
                                        By signing in or signing up, I agree to
                                        myhomehelper.com's{" "}
                                        {/* <a href="#">
                                            Terms of Service
                                        </a> and  */}
                                        <Link to="/privacy-policy">
                                            Privacy Policy
                                        </Link>
                                        , confirm that I am 18 years of age or
                                        older, and consent to receiving email
                                        communication.
                                    </p>
                                </div>
                                <div className="have_account">
                                    <p>
                                        Not a Member?
                                        <Link to="/signup" className="ml-2">
                                            Sign up
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Sign In ec Start Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo1} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo2} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo3} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo4} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo5} alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src={clientLogo6} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    loginAction: async (email, password) =>
        dispatch(await LoginAction(email, password)),
    socialLoginAction: async (
        first_name,
        last_name,
        email,
        social_id,
        profile_picture
    ) =>
        dispatch(
            await SocialLoginAction(
                first_name,
                last_name,
                email,
                social_id,
                profile_picture
            )
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
